export default "__VITE_ASSET__BO_E6$9M__"